import { render, staticRenderFns } from "./ProductStarRate.vue?vue&type=template&id=9f03df0a&"
import script from "./ProductStarRate.vue?vue&type=script&lang=js&"
export * from "./ProductStarRate.vue?vue&type=script&lang=js&"
import style0 from "./ProductStarRate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports